import React ,{useState,useEffect} from "react";
import { at } from "lodash";
import { useField } from "formik";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
} from "@material-ui/core";

export default function DiamTypeCheck(props) {
    const { label, ...rest } = props;
    const [field, meta, helper] = useField(props);
    // console.log(meta.error,"ERRORRRRRMETA")
    const [border,setBorder] = useState("")
    useEffect(() => {
        if(props.values && (props.values.naturaldiamond || props.values.naturalfancydiamond || props.values.lgwhitediam || props.values.lgfancydiam)){
            setBorder("")

        }else{
            setBorder("border-danger")
        }
    },[props.values])
    const { setValue } = helper;
    function _renderHelperText() {
        const [touched, error] = at(meta, "touched", "error");
        if (touched && error) {
            return <FormHelperText>{error}</FormHelperText>;
        }
    }

    function _onChange(e) {
    // console.log(props,"FIELDESSSS")
    // console.log(props.values[`${props.name}`],"NAMESSSSS")
    console.log(props.location.state,"props.location.state")
    console.log(props.values.multi_currency,"props.values.multi_currency")
    if(props.values[`${props.name}`]){
    props.setFieldValue(props.name,'')
    }
    else{
    props.setFieldValue(props.name,props.name)

    }
    props.setSelectAllFields(false)
    props.setSelectAllFieldsLab(false)
    if(props.name === "naturaldiamond"){
        props.setValues({
      "rulename": props.values.rulename,
      "naturaldiamond": 1,
      "naturalfancydiamond": '',
      "lgwhitediam": '',
      "lgfancydiam": '',
      "diamondshape": [],
      "carat_from": '0.18',
      "carat_to": '10.00',
      "diamondcolor": [],
      "diamondfancy_color": [],
      "diamondfancy_intensity": [],
      "diamondfancy_overtone": [],
      "diamondclarity": [],
      "lab_val": [],
      "cuts": [],
      "diamondflour": [],
      "polishes": [],
      "symmetries": [],
      "diamondshade": [],
      "milky": [],
      "eyeclean": [],
      "price_from": '0',
      "price_to": '999999',
      "total_price_from": '0',
      "total_price_to": '999999',
      "media": [],


      "lab_shape": [],
      "lab_carat_from": '0.18',
      "lab_carat_to": '10.00',
      "lab_color": [],
      "lab_fancy_color": [],
      "lab_fancy_intensity": [],
      "lab_fancy_overtone": [],
      "lab_clarity": [],
      "lab_lab": [],
      "lab_cuts": [],
      "lab_polishes": [],
      "lab_symmetries": [],
      "lab_flourselect": [],
      "lab_shadeselect": [],
      "lab_milky": [],
      "lab_eyeclean": [],
      "lab_min_dollarperct": '0',
      "lab_max_dollarperct": '999999',
      "lab_total_price_from": '0',
      "lab_total_price_to": '999999',
      "lab_all_media": [],


        // [muti_currency": 'INR',
        
      "dbfetch":false,
      "markupvalue":'',
      "markupoption":'',
      "suppliers":[],
      "multi_currency":props.location.state.currencyvalue?props.location.state.currencyvalue:props.values.multi_currency,
      "brand":[],
      "origin":[],
      "treatment":[],
      "keytosymbol":[],
      "labbrand":[],
      "laborigin":[],
      "labtreatment":[],
      "labkeytosymbol":[],
      "caratpricemarkups":[]
      })
    }
    if(props.name === "naturalfancydiamond"){
        props.setValues({
            "rulename": props.values.rulename,
            "naturaldiamond": '',
            "naturalfancydiamond": 1,
            "lgwhitediam": '',
            "lgfancydiam": '',
            "diamondshape": [],
            "carat_from": '0.18',
            "carat_to": '10.00',
            "diamondcolor": [],
            "diamondfancy_color": [],
            "diamondfancy_intensity": [],
            "diamondfancy_overtone": [],
            "diamondclarity": [],
            "lab_val": [],
            "cuts": [],
            "diamondflour": [],
            "polishes": [],
            "symmetries": [],
            "diamondshade": [],
            "milky": [],
            "eyeclean": [],
            "price_from": '0',
            "price_to": '999999',
            "total_price_from": '0',
            "total_price_to": '999999',
            "media": [],
      
      
            "lab_shape": [],
            "lab_carat_from": '0.18',
            "lab_carat_to": '10.00',
            "lab_color": [],
            "lab_fancy_color": [],
            "lab_fancy_intensity": [],
            "lab_fancy_overtone": [],
            "lab_clarity": [],
            "lab_lab": [],
            "lab_cuts": [],
            "lab_polishes": [],
            "lab_symmetries": [],
            "lab_flourselect": [],
            "lab_shadeselect": [],
            "lab_milky": [],
            "lab_eyeclean": [],
            "lab_min_dollarperct": '0',
            "lab_max_dollarperct": '999999',
            "lab_total_price_from": '0',
            "lab_total_price_to": '999999',
            "lab_all_media": [],
      
      
              // [muti_currency": 'INR',
              
            "dbfetch":false,
            "markupvalue":'',
            "markupoption":'',
            "suppliers":[],
            "multi_currency":props.location.state.currencyvalue?props.location.state.currencyvalue:props.values.multi_currency,
            "brand":[],
            "origin":[],
            "treatment":[],
            "keytosymbol":[],
            "labbrand":[],
            "laborigin":[],
            "labtreatment":[],
            "labkeytosymbol":[],
            "caratpricemarkups":[]
            })
    }
    if(props.name === "lgwhitediam"){
        props.setValues({
            "rulename": props.values.rulename,
            "naturaldiamond": '',
            "naturalfancydiamond": '',
            "lgwhitediam": 1,
            "lgfancydiam": '',
            "diamondshape": [],
            "carat_from": '0.18',
            "carat_to": '10.00',
            "diamondcolor": [],
            "diamondfancy_color": [],
            "diamondfancy_intensity": [],
            "diamondfancy_overtone": [],
            "diamondclarity": [],
            "lab_val": [],
            "cuts": [],
            "diamondflour": [],
            "polishes": [],
            "symmetries": [],
            "diamondshade": [],
            "milky": [],
            "eyeclean": [],
            "price_from": '0',
            "price_to": '999999',
            "total_price_from": '0',
            "total_price_to": '999999',
            "media": [],
      
      
            "lab_shape": [],
            "lab_carat_from": '0.18',
            "lab_carat_to": '10.00',
            "lab_color": [],
            "lab_fancy_color": [],
            "lab_fancy_intensity": [],
            "lab_fancy_overtone": [],
            "lab_clarity": [],
            "lab_lab": [],
            "lab_cuts": [],
            "lab_polishes": [],
            "lab_symmetries": [],
            "lab_flourselect": [],
            "lab_shadeselect": [],
            "lab_milky": [],
            "lab_eyeclean": [],
            "lab_min_dollarperct": '0',
            "lab_max_dollarperct": '999999',
            "lab_total_price_from": '0',
            "lab_total_price_to": '999999',
            "lab_all_media": [],
      
      
              // [muti_currency": 'INR',
              
            "dbfetch":false,
            "markupvalue":'',
            "markupoption":'',
            "suppliers":[],
            "multi_currency":props.location.state.currencyvalue?props.location.state.currencyvalue:props.values.multi_currency,
            "brand":[],
            "origin":[],
            "treatment":[],
            "keytosymbol":[],
            "labbrand":[],
            "laborigin":[],
            "labtreatment":[],
            "labkeytosymbol":[],
            "caratpricemarkups":[]
            })
    }
    if(props.name === "lgfancydiam"){
        props.setValues({
            "rulename": props.values.rulename,
            "naturaldiamond": '',
            "naturalfancydiamond": '',
            "lgwhitediam": '',
            "lgfancydiam": 1,
            "diamondshape": [],
            "carat_from": '0.18',
            "carat_to": '10.00',
            "diamondcolor": [],
            "diamondfancy_color": [],
            "diamondfancy_intensity": [],
            "diamondfancy_overtone": [],
            "diamondclarity": [],
            "lab_val": [],
            "cuts": [],
            "diamondflour": [],
            "polishes": [],
            "symmetries": [],
            "diamondshade": [],
            "milky": [],
            "eyeclean": [],
            "price_from": '0',
            "price_to": '999999',
            "total_price_from": '0',
            "total_price_to": '999999',
            "media": [],
      
      
            "lab_shape": [],
            "lab_carat_from": '0.18',
            "lab_carat_to": '10.00',
            "lab_color": [],
            "lab_fancy_color": [],
            "lab_fancy_intensity": [],
            "lab_fancy_overtone": [],
            "lab_clarity": [],
            "lab_lab": [],
            "lab_cuts": [],
            "lab_polishes": [],
            "lab_symmetries": [],
            "lab_flourselect": [],
            "lab_shadeselect": [],
            "lab_milky": [],
            "lab_eyeclean": [],
            "lab_min_dollarperct": '0',
            "lab_max_dollarperct": '999999',
            "lab_total_price_from": '0',
            "lab_total_price_to": '999999',
            "lab_all_media": [],
      
      
              // [muti_currency": 'INR',
              
            "dbfetch":false,
            "markupvalue":'',
            "markupoption":'',
            "suppliers":[],
            "multi_currency":props.location.state.currencyvalue?props.location.state.currencyvalue:props.values.multi_currency,
            "brand":[],
            "origin":[],
            "treatment":[],
            "keytosymbol":[],
            "labbrand":[],
            "laborigin":[],
            "labtreatment":[],
            "labkeytosymbol":[],
            "caratpricemarkups":[]
            })
    }
    }
    // console.log(props.name,"PVALLLL")
    console.log(props.values,"VALUESSSSS")
    // console.log(props.values[`${props.name}`],"FINALLLL")
    return (
       <>
       <label className="table_cell_checkmark1 multitab_diam " >
            <div className={`text-center mt-2 multitab_diam_box naturaldiamond checkbox ${border}`}>
              <div
                  className={`${
                      props.name === "naturaldiamond" ? "white_dia_icon" 
                      : props.name === "naturalfancydiamond" ? "fancy_dia_icon" 
                      : props.name === "lgwhitediam" ? "lab_dia_icon" 
                      : props.name === "lgfancydiam" ? "lab_fancy_dia_icon" : ""
                    }`}
                ></div>
                <input type="checkbox" name={props.name} value={field.checked} id={props.name} className="check_box_all"  checked={meta.value} onChange={_onChange} error={meta.touched && meta.error && true}/>
                <span className="checkmark1"></span>
                <p className="m-0 mt-2">{label}</p>
            </div>
        </label>
       </>
    );
}
